import { Component } from '@angular/core';
import { InvoicesService } from '../invoices/invoices.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-download-invoice',
  templateUrl: './download-invoice.component.html',
  styleUrls: ['./download-invoice.component.scss']
})
export class DownloadInvoiceComponent {
  ID: any
  printData: any
  loader=false;
  constructor(public activatedRoute: ActivatedRoute,
    public service: InvoicesService,
    private toastr: ToastrService
  ) {
    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    this.LoadData()
  }
  Reset(){
    this.printData={
      cancled:null,
      discount:0,
      due:0,
      eendDate:"", //new Date(),
      exportedInvoiceItems:[],
      invoiceNo:"",
      orderNumber:'',
      quantity:parseFloat('0'),
      retailPrice:parseFloat('0'),
      paid:0,
      retailerName:"",
      startDate:"",
      subTotal:0,
      total:0
    }
  }
  LoadData() {
    this.loader=true
    this.service.printInvoice(this.ID).subscribe
      ({
        next: (res: any) => {
          console.log(res)
          this.printData=res
          this.loader=false
        },
        error: e => {
          if (e.error.message) {
            this.loader=false
            this.toastr.error('Oops!', e.error.message);
          }
          else {
            this.loader=false
            this.toastr.error('Oops!', "Something went wrong");
          }
        }
      })
  }
}
